module.exports = __webpack_public_path__ + "img/20190912105208360截图20190912093946703.9bfc0488.jpg";